/**
 * @module
 * @format
 */

/**
 * @import {UserImageWaiting} from '../image/waiting.js';
 */

import {click, reactive} from 'nova';
import {SCOPE, UPGRADE} from '@acng/frontend-stargazer';
import {guard, INTEGER} from '@acng/frontend-rubicon';
import {portal} from '../../../core/portal.js';
import {user} from '../../user.js';

class UserProfileImageTest {
  [SCOPE] = this;
  @reactive accessor hasWaiting = false;
  @reactive accessor res = '';
  waitingId = NaN;

  /**
   * @todo Call `sync` from {@link UserImageWaiting}
   */
  [UPGRADE]() {
    this.sync();
  }

  /**
   * Check waiting image.
   */
  async sync() {
    const id = await this.#get();
    this.hasWaiting = !!id;
    this.waitingId = id ? id : NaN;
  }

  @click accept() {
    this.#put(true);
  }

  @click decline() {
    this.#put(false);
  }

  @click async delete() {
    const init = {
      method: 'DELETE',
      headers: {'UserPool': `${user.pool_id}`},
    };

    const res = await fetch(`/iapi/user-profile/${user.id}/image`, init);
    this.res = await res.text();
  }

  /**
   * @param {boolean} accepted
   * @returns {Promise<void>}
   */
  async #put(accepted) {
    const id = this.waitingId;

    if (!id) {
      throw this;
    }

    const init = {
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      body: `{"accepted": ${accepted}, "fsk": 18}`,
    };

    const res = await fetch(`/iapi/user-image/waiting/${id}`, init);

    this.res = await res.text();
    this.hasWaiting = false;
    this.waitingId = 0;
  }

  /**
   * @returns {Promise<number>} The next waiting image id
   */
  async #get() {
    const init = {
      method: 'GET',
      headers: {'X-WhitelabelId': `${portal.id}`},
    };

    const res = await fetch(`/iapi/user-image/waiting`, init);

    if (res.status == 204) {
      return 0;
    }

    const data = await res.json();
    ASSERT: guard(data.id, INTEGER);
    this.res = JSON.stringify(data, undefined, 2);

    return data.id;
  }
}

export {UserProfileImageTest};
